import { defineStore } from "pinia"
import { queryClient } from "~/plugins/vue-query"
import type { ProducerCompanyKind, Scope, User as ZefireUser } from "~/utils/schemas"

interface MainStoreInterface {
  user: Readonly<ZefireUser>

  token: Readonly<{
    permissions: Scope[]
    raw: string
    decoded: Record<string, any>
  }>
  isIdleSession: boolean

  showGlobalSearch: boolean // whether to show global search modal

  gmapCenter?: { lat: number; lng: number }
  isViewLoading: boolean
}

export const useMainStore = defineStore("main", {
  state: () =>
    ({
      user: undefined as any,
      token: {} as any,
      isIdleSession: false,
      showGlobalSearch: false,
      // WARNING Vue reactive function is called on the initial state,
      // hence we absolutely need to pass every attributes of the interface
      // even though gmapCenter is optional as we need the reactivity on it
      gmapCenter: undefined,
      isViewLoading: false,
      pageActions: ref([]),
    }) as MainStoreInterface,
  getters: {
    userCompanyQuery(state): { uuid: string; model: ProducerCompanyKind } {
      const model = state.user.company.kind as ProducerCompanyKind
      const uuid = state.user.company.uuid as string
      return { model, uuid }
    },
  },
  actions: {
    async fetchZefireUser(): Promise<ZefireUser> {
      // Use queryClient.ensureQueryData to fetch and cache user info
      // This works outside of setup context (e.g., in middleware) and ensures
      // the data is cached for components using useGetUserInfos()
      this.user = await queryClient.ensureQueryData({
        queryKey: ["user", "me"],
        queryFn: async () => await useApiClient().get_me(),
        staleTime: 24 * 60 * 60 * 1000, // 24 hours
      })

      return this.user
    },
  },
})
